import { z } from "zod";

/**
 * Public community ranks, lowest to highest. This list is used for member
 * profiles and community rank history; Sysadmin is an access level, not a
 * public rank.
 */
export const ROLES = [
  "applicant",
  "recruit",
  "member",
  "staff_in_training",
  "staff",
  "senior_staff",
  "junior_administration",
  "administration",
  "senior_administration",
  "head_administration",
] as const;

export const RoleSchema = z.enum(ROLES);
export type Role = z.infer<typeof RoleSchema>;

/** Hub access levels include the non-public Sysadmin level above public ranks. */
export const HUB_ROLES = [...ROLES, "sysadmin"] as const;
export const HubRoleSchema = z.enum(HUB_ROLES);
export type HubRole = z.infer<typeof HubRoleSchema>;

/** Cross-cutting team memberships (not part of the linear hierarchy). */
export const TEAMS = ["internal_affairs"] as const;
export const TeamSchema = z.enum(TEAMS);
export type Team = z.infer<typeof TeamSchema>;

export function rolePrivilege(role: Role): number {
  return ROLES.indexOf(role);
}

export function hubRolePrivilege(role: HubRole): number {
  return HUB_ROLES.indexOf(role);
}

export function hasAtLeast(role: HubRole, min: HubRole): boolean {
  return hubRolePrivilege(role) >= hubRolePrivilege(min);
}
